import React, { ReactNode } from 'react'

interface MinimalLayoutProps {
  children: ReactNode
}

const MinimalLayout: React.FC<MinimalLayoutProps> = ({ 
  children 
}) => {

  // Apply theme-specific body background
  React.useEffect(() => {
    // Clean body classes
    document.body.className = ''
    document.body.style.cssText = ''
    
    return () => {
      // Clean up on unmount
      document.body.className = ''
      document.body.style.cssText = ''
    }
  }, [])

  return (
    <>
      {/* Background div like in original signup.html */}
      <div className="bg-fixed"></div>
      
      {/* Main content */}
      {children}
      
      {/* Footer like in original signup.html */}
      <footer className="footer c-red text-center py-2 mb-4 animateMe" data-animation="fadeInUp">
        <small>Copyright © 2023-2024 All rights reserved.</small>
      </footer>
    </>
  )
}

export default MinimalLayout
